import { Option } from '@sapphire/result';
import { Nullable } from '@ps/utils';

import { TemplateFolder, TemplateSummary } from '../../models';

/**
 * A template plus the folder that holds it. Updating a template has to send its
 * folder back, and `TemplateSummary` does not carry one — the tree position is
 * the only place that relationship exists.
 */
export interface TemplateLocation {
  readonly template: TemplateSummary;
  readonly folderId: number;
}

export function findTemplateLocation(
  folders: readonly TemplateFolder[],
  templateId: Nullable<number>,
): Option<TemplateLocation> {
  if (!templateId) {
    return Option.none;
  }

  for (const folder of folders) {
    const found = Option.from(
      folder.templates.find((template) => template.id === templateId),
    )
      .map((template) => ({ template, folderId: folder.id }))
      .orElse(() => findTemplateLocation(folder.subfolders ?? [], templateId));

    if (found.isSome()) {
      return found;
    }
  }

  return Option.none;
}
